import React from "react";
import "./Tooltip.scss";
import type { ReactNode } from "react";

function Tooltip({ children }: { children: ReactNode }) {
	return <div className="Tooltip-Content">{children}</div>;
}

export default Tooltip;
